class CollectionFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.filterData = [];
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    this.productGridId = 'CollectionProductGrid';
    this.filterFormsId = 'CollectionFiltersForm';
    this.searchTemplate = document.querySelector('body.template-search');
    this.collectionTemplate = document.querySelector('body.template-collection');
    this.sections = this.getSections();

    function debounce(fn, wait) {
      let t;
      return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
      };
    }

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    this.querySelector('form').addEventListener('input', this.debouncedOnSubmit.bind(this));
    this.drawerOpenBtn = this.closest('#main-collection-filters').querySelector('[data-drawer-open-btn]');
    this.drawerCloseBtn = this.querySelector('[data-drawer-close-btn]');
    this.drawerOverlay = document.querySelector('#NavDrawerOverlay');
    this.handleDrawerOpen = this.handleDrawerOpen.bind(this);
    this.handleDrawerClose = this.handleDrawerClose.bind(this);
    this.handleDrawerKeydown = this.handleDrawerKeydown.bind(this);
    this.syncDrawerLayout = this.syncDrawerLayout.bind(this);
    this.drawerOpenBtn.addEventListener('click', this.handleDrawerOpen);
    this.drawerCloseBtn?.addEventListener('click', this.handleDrawerClose);
    this.drawerOverlay?.addEventListener('click', this.handleDrawerClose);
    this.addEventListener('keydown', this.handleDrawerKeydown);
    this.addEventListener('toggle', () => this.positionFacetPanels(), true);
    window.addEventListener('resize', this.syncDrawerLayout);
    this.syncDrawerLayout();
    window.addEventListener('popstate', this.onHistoryChange.bind(this));

    this.bindActiveFacetButtonEvents();
    this.onDropDownBlur();
  }

  onDropDownBlur() {
    const getDropDowns = document.querySelectorAll('details');

    for (let item of getDropDowns) {
      document.addEventListener('click', function (event) {
        var isClickInside = item.contains(event.target);

        if (!isClickInside) {
          //the click was outside the specifiedElement, close the dropdown
          item.removeAttribute('open');
        }
      });
    }
  }

  isDrawerLayout() {
    // Follow the rendered layout, including responsive search and collection styles.
    return window.getComputedStyle(this).position === 'fixed';
  }

  syncDrawerLayout() {
    const mobile = this.isDrawerLayout();
    const focusWasInside = this.contains(document.activeElement);
    if (!mobile && this.classList.contains('is-open')) {
      this.classList.remove('is-open');
      document.body.classList.remove('js-drawer-open-left', 'js-drawer-open');
    }
    const open = mobile && this.classList.contains('is-open');
    this.id = this.id || 'sgg-collection-filter-drawer';
    this.drawerOpenBtn.setAttribute('aria-controls', this.id);
    this.drawerOpenBtn.setAttribute('aria-expanded', String(open));
    this.toggleAttribute('inert', mobile && !open);
    if (mobile) {
      this.setAttribute('aria-hidden', String(!open));
      this.setAttribute('role', 'dialog');
      this.setAttribute('aria-label', this.drawerOpenBtn.textContent.trim());
      if (open) this.setAttribute('aria-modal', 'true');
      else this.removeAttribute('aria-modal');
    } else {
      ['aria-hidden', 'role', 'aria-label', 'aria-modal'].forEach(name => this.removeAttribute(name));
    }
    if (focusWasInside && mobile && !open) this.drawerOpenBtn.focus();
    if (focusWasInside && !mobile && !this.isVisibleControl(document.activeElement)) {
      this.drawerFocusableElements()[0]?.focus();
    }
    this.positionFacetPanels();
  }

  positionFacetPanels() {
    const mobile = this.isDrawerLayout();
    const viewportWidth = document.documentElement.clientWidth;
    this.querySelectorAll('.facets__disclosure > .facets__display').forEach(panel => {
      panel.style.removeProperty('transform');
      panel.style.removeProperty('max-width');
      if (mobile || !panel.parentElement.open) return;
      panel.style.maxWidth = `${Math.max(0, viewportWidth - 32)}px`;
      const bounds = panel.getBoundingClientRect();
      const shift = Math.min(0, viewportWidth - 16 - bounds.right) + Math.max(0, 16 - bounds.left);
      if (shift) panel.style.transform = `translateX(${shift}px)`;
    });
  }

  isVisibleControl(element) {
    if (!element || element.closest('[inert]') || !element.getClientRects().length) return false;
    const style = window.getComputedStyle(element);
    if (style.visibility === 'hidden' || style.display === 'none') return false;
    for (let parent = element.parentElement; parent && parent !== this; parent = parent.parentElement) {
      if (parent.matches('details:not([open])') && !parent.querySelector('summary')?.contains(element)) return false;
    }
    return true;
  }

  drawerFocusableElements() {
    return Array.from(this.querySelectorAll('button, a[href], input:not([type="hidden"]), select, textarea, summary, [tabindex]'))
      .filter(element => element.tabIndex >= 0 && !element.matches(':disabled') && this.isVisibleControl(element));
  }

  handleDrawerOpen(event) {
    if (!this.isDrawerLayout()) return;
    event.preventDefault();
    this.classList.add('is-open');
    document.body.classList.add('js-drawer-open-left', 'js-drawer-open');
    this.syncDrawerLayout();
    this.drawerCloseBtn?.focus({ preventScroll: true });
  }

  handleDrawerClose() {
    // The overlay is shared with navigation; a closed filter must not close another drawer.
    if (!this.classList.contains('is-open')) return;
    this.classList.remove('is-open');
    document.body.classList.remove('js-drawer-open-left', 'js-drawer-open');
    if (this.isDrawerLayout()) this.drawerOpenBtn.focus({ preventScroll: true });
    this.syncDrawerLayout();
  }

  handleDrawerKeydown(event) {
    if (!this.isDrawerLayout() || !this.classList.contains('is-open')) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      event.stopPropagation();
      this.handleDrawerClose();
      return;
    }
    if (event.key !== 'Tab') return;
    // Recalculate after expanded groups and asynchronously updated filters.
    const controls = this.drawerFocusableElements();
    const first = controls[0];
    const last = controls[controls.length - 1];
    if (!first) return;
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }


  onSubmitHandler(event) {
    event.preventDefault();
    if (this.collectionTemplate) {
      const formData = new FormData(event.target.closest('form'));
      const searchParams = new URLSearchParams(formData).toString();
      this.renderPage(searchParams, event);
    } else if (this.searchTemplate) {
      // Store the initial URL so that we can get the search query from it to add to the formData object
      const searchParamsInitial = new URLSearchParams(window.location.search);

      // Get the selected result types, we will need to use them later on
      const activeTypes = document.querySelector('#page-type-input').value;
      const types = Array.from(activeTypes.split(','));
      const defaultTypes = document.querySelector('.search--header input[name="type"]');

      if (activeTypes == "") {
        const getInput = document.querySelector('#page-type-input');
        getInput.value = defaultTypes.value;
      }

      // Add the initial search query to the formData object otherwise the query will be lost and we will get an error
      const formData = new FormData(event.target.closest('form'));
      formData.append('q', searchParamsInitial.get('q'));

      // If the result type is not of type product, we want to disable the filter inputs and remove product type queries from the URL
      if (types.includes('article') && !types.includes('product') || types.includes('page') && !types.includes('product')) {
        const getInputs = document.querySelectorAll(`#${this.filterFormsId} input:not(#page-type-input)`);
        const getLabels = document.querySelectorAll(`#${this.filterFormsId} label:not(.collection-filters__label)`);

        // Disable the inputs if the result type is article or page
        for (let item of getInputs) {
          item.setAttribute('disabled', 'disabled');
        }

        for (let inputLabel of getLabels) {
          inputLabel.classList.add('facet-checkbox--disabled');
        }

        // If our result is an article or page type, remove all product related filters from the URL
        if (searchParamsInitial.has('filter.p.product_type')) {
          let newFormData = new URLSearchParams(window.location.search).toString();
          formData.delete('filter.p.product_type');
          this.renderPage(newFormData, event);
        }

        if (searchParamsInitial.has('filter.p.vendor')) {
          let newFormData = new URLSearchParams(window.location.search).toString();
          formData.delete('filter.p.vendor');
          this.renderPage(newFormData, event);
        }

        if (searchParamsInitial.has('filter.v.availability')) {
          let newFormData = new URLSearchParams(window.location.search).toString();
          formData.delete('filter.v.availability');
          this.renderPage(newFormData, event);
        }
      }

      const searchParams = new URLSearchParams(formData).toString();
      this.renderPage(searchParams, event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    this.toggleActiveFacets();
    this.renderPage(new URL(event.currentTarget.href).searchParams.toString());
  }

  onHistoryChange() {
    const searchParams = new URLSearchParams(window.location.search).toString();
    this.renderPage(searchParams, null, false);
  }

  toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  renderPage(searchParams, event, updateURLHash = true) {
    document.querySelector(`#${this.productGridId}>div`).classList.add('loading');

    this.sections.forEach((section) => {
      if (this.collectionTemplate) {
        const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
        const filterDataUrl = element => element.url === url;

        this.filterData.some(filterDataUrl) ?
          this.renderSectionFromCache(filterDataUrl, section, event) :
          this.renderSectionFromFetch(url, section, event);
      } else if (this.searchTemplate) {
        const url = `${window.location.pathname}?${searchParams}`;
        const filterDataUrl = element => element.url === url;

        this.filterData.some(filterDataUrl) ?
          this.renderSectionFromCache(filterDataUrl, section, event) :
          this.renderSectionFromFetch(url, section, event);
      }
    });

    if (updateURLHash) this.updateURLHash(searchParams);
  }

  renderSectionFromFetch(url, section, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        this.filterData = [...this.filterData, { html, url }];

        switch (section.id) {
          case this.productGridId:
            this.renderProductGrid(html);
            break;
          case this.filterFormsId:
            this.renderFilters(html, event);
            break;
          default:
            return;
        }
      });
  }

  renderSectionFromCache(filterDataUrl, section, event) {
    const html = this.filterData.find(filterDataUrl).html;
    this.renderFilters(html, event);
    this.renderProductGrid(html);
  }

  renderProductGrid(html) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const innerHTML = parsedHTML.getElementById(this.productGridId).innerHTML;

    document.getElementById(this.productGridId).innerHTML = innerHTML;

    // Keep the search title aligned with the newly rendered results.
    if (this.searchTemplate && parsedHTML.title.trim()) {
      document.title = parsedHTML.title.trim();
      const heading = document.querySelector('.search--header h1');
      const nextHeading = parsedHTML.querySelector('.search--header h1');
      if (heading && nextHeading) heading.textContent = nextHeading.textContent;
    }

    const event = new CustomEvent('paginate');
    document.dispatchEvent(event);
  }

  renderFilters(html, event) {
    const focused = this.contains(document.activeElement) ? document.activeElement : null;
    const focusedId = focused?.id;
    const focusedGroup = focused?.closest('.js-filter')?.dataset.index;
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    if (!event) {
      const sortBy = this.querySelector('#SortBy');
      const nextSortBy = parsedHTML.querySelector('#SortBy');
      if (sortBy && nextSortBy) sortBy.value = nextSortBy.value;
    }

    const facetDetailsElements =
      parsedHTML.querySelectorAll(`#${this.filterFormsId} .js-filter`);
    const matchesIndex = (element) => element.dataset.index === event?.target.closest('.js-filter')?.dataset.index
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    this.renderActiveFacets(parsedHTML);

    if (countsToRender) this.renderCounts(countsToRender, event.target.closest('.js-filter'));
    if (focused && !focused.isConnected && (document.activeElement === document.body || document.activeElement === null)) {
      const sameControl = focusedId ? document.getElementById(focusedId) : null;
      const groupSummary = Array.from(this.querySelectorAll('.js-filter'))
        .find(group => group.dataset.index === focusedGroup)?.querySelector('summary');
      const replacement = [sameControl, groupSummary, ...this.drawerFocusableElements()]
        .find(element => element && this.contains(element) && this.isVisibleControl(element));
      replacement?.focus({ preventScroll: true });
    }
    this.positionFacetPanels();
  }

  renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    })

    this.bindActiveFacetButtonEvents();
    this.toggleActiveFacets(false);
  }

  renderMobileElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count'];

    mobileElementSelectors.forEach((selector) => {
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });
  }

  renderCounts(source, target) {
    const countElementSelectors = ['.count-bubble', '.facets__selected'];
    countElementSelectors.forEach((selector) => {
      const targetElement = target.querySelector(selector);
      const sourceElement = source.querySelector(selector);

      if (sourceElement && targetElement) {
        target.querySelector(selector).outerHTML = source.querySelector(selector).outerHTML;
      }
    });
  }

  bindActiveFacetButtonEvents() {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.addEventListener('click', this.onActiveFilterClick, { once: true });
    });
  }

  updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  getSections() {
    return [
      {
        id: this.productGridId,
        section: document.getElementById(this.productGridId).dataset.sectionId
      },
      {
        id: this.filterFormsId,
        section: document.getElementById('main-collection-filters').dataset.id
      }
    ]
  }
}

customElements.define('collection-filtering-form', CollectionFiltersForm);

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));

    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', '0');
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range-selector', PriceRange);

class PageType extends HTMLElement {
  constructor() {
    super()
    this.selector = document.querySelector('[data-page-type-selector]');
    this.selector.addEventListener('change', this.setValue);
  }

  setValue(e) {
    const selectedTypes = e.currentTarget.querySelectorAll('input:checked');
    const types = Array.from(selectedTypes).map(option => option.value).join(',');

    const typeInput = document.querySelector('#page-type-input');
    typeInput.value = types;

    const event = new Event('input');
    typeInput.closest('form').dispatchEvent(event);
  }
}

customElements.define('page-type-selector', PageType);
